import { render, staticRenderFns } from "./LegacyOrderWizard.vue?vue&type=template&id=652a8c99"
import script from "./LegacyOrderWizard.vue?vue&type=script&lang=js"
export * from "./LegacyOrderWizard.vue?vue&type=script&lang=js"
import style0 from "./LegacyOrderWizard.vue?vue&type=style&index=0&id=652a8c99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports